import React, { useEffect, useRef } from 'react';
import Plyr from 'plyr';
import 'plyr/dist/plyr.css';
import Hls from 'hls.js';
import './StreamRecord.css';

export const StreamRecord = ({ options, onReady }) => {
    const videoRef = useRef(null);
    const playerRef = useRef(null);

    useEffect(() => {
        const video = videoRef.current;
        if (!video) return;

        const isMobile = window.innerWidth <= 768;

        const controls = [
            'rewind', 'play', 'fast-forward', 'progress', 'current-time', 'mute', 'volume', 'settings', 'fullscreen'
        ];

        if (!isMobile) {
            controls.push('pip'); // Добавляем PiP только на десктопе
        } else {
            video.setAttribute("controls", "true"); // Включаем встроенные контролы браузера
        }

        const player = new Plyr(video, {
            controls,
            settings: ['speed', 'quality'],
            i18n: {
                restart: 'Перезапустить',
                rewind: 'Назад {seektime} сек',
                play: 'Воспроизвести',
                pause: 'Пауза',
                fastForward: 'Вперёд {seektime} сек',
                seek: 'Перемотка',
                seekLabel: '{currentTime} из {duration}',
                played: 'Просмотрено',
                buffered: 'Буферизация',
                currentTime: 'Текущее время',
                duration: 'Длительность',
                volume: 'Громкость',
                mute: 'Выключить звук',
                unmute: 'Включить звук',
                captions: 'Субтитры',
                settings: 'Настройки',
                pip: 'Картинка в картинке',
                menuBack: 'Назад',
                speed: 'Скорость',
                normal: 'Обычная',
                quality: 'Качество',
                loop: 'Повтор',
                start: 'Начать',
                end: 'Конец',
                all: 'Все',
                reset: 'Сброс',
                disabled: 'Отключено',
                enabled: 'Включено',
            }
        });

        if (Hls.isSupported() && options.sources[0]?.src.endsWith('.m3u8')) {
            const hls = new Hls();
            hls.loadSource(options.sources[0].src);
            hls.attachMedia(video);
            hls.on(Hls.Events.MANIFEST_PARSED, () => {
                player.on('ready', () => onReady && onReady(player));
                playerRef.current = player;
            });
        } else {
            player.on('ready', () => onReady && onReady(player));
            playerRef.current = player;
        }

        return () => {
            if (playerRef.current) {
                playerRef.current.destroy();
                playerRef.current = null;
            }
        };
    }, [options]);

    return (
        <div className="plyr-container">
            <video ref={videoRef} className="plyr" controls />
        </div>
    );
};

export default StreamRecord;
